const transposeOptions = filter => {
  const options = [];
  for (const option of filter.options) {
    const {
      label,
      id,
      value,
      description
    } = option;
    options.push({
      __typename: 'MarketplaceFilterOption',
      label,
      id,
      value,
      description: description !== null && description !== void 0 ? description : null
    });
  }
  return {
    __typename: 'MarketplaceFilterOptionResult',
    options,
    error: filter.error ? {
      __typename: 'MarketplaceSearchFilterError',
      message: filter.error.message
    } : null
  };
};
export const SearchFilterTranspose = data => {
  return {
    marketplaceFilters: {
      __typename: 'MarketplaceFilters',
      product: transposeOptions(data.product),
      hosting: transposeOptions(data.hosting),
      price: transposeOptions(data.price),
      trustSignals: transposeOptions(data.trustSignals),
      other: transposeOptions(data.other),
      categories: transposeOptions(data.categories),
      useCases: transposeOptions(data.useCases)
    }
  };
};